// Routes des actions sociales (lot L7, M20), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageDemandeSociale } from './PageDemandeSociale';
import { PageSocial } from './PageSocial';

export const routesSocial: RouteObject[] = [
  { path: '/social', element: <PageSocial /> },
  { path: '/social/demandes/:id', element: <PageDemandeSociale /> },
];
